import { PopoverComponent } from './popover.component'

export class PopoverStore {
    private popovers: PopoverComponent[] = []

    private static _instance: PopoverStore
    public static getInstance(): PopoverStore {
        return this._instance || (this._instance = new this())
    }

    public add(popover: PopoverComponent): void {
        this.popovers.push(popover)
    }

    public close(): void {
        this.popovers.forEach((popover) => {
            popover.close()
        })
    }
}
